<p>data-generate works!</p>
